/* REDY: topografinės linijos, kelionės tipo jungiklis, prekių žymos ir kelionės sąrašas. */
(function () {
  var KEY = 'redy-mode';
  var DEFAULT = 'fly';

  /* ---------- topografinės linijos ---------- */
  function rng(s) { return function () { s = (s * 9301 + 49297) % 233280; return s / 233280; }; }
  function drawTopo(svg, i) {
    if (svg.dataset.drawn) return;
    if (!svg.getAttribute('viewBox')) svg.setAttribute('viewBox', '0 0 1000 700');
    svg.setAttribute('preserveAspectRatio', 'xMidYMid slice');
    var vb = svg.getAttribute('viewBox').split(' ').map(Number), vw = vb[2], vh = vb[3];
    var r = rng(7 + i * 13), centers = +svg.dataset.redyTopo || 2, out = '';
    for (var c = 0; c < centers; c++) {
      var cx = r() * vw, cy = r() * vh, ph = [r() * 6, r() * 6, r() * 6];
      for (var k = 1; k <= 14; k++) {
        var R = k * vw * 0.03, d = '';
        for (var j = 0; j <= 72; j++) {
          var a = j / 72 * Math.PI * 2;
          var m = 1 + 0.18 * Math.sin(2 * a + ph[0]) + 0.1 * Math.sin(3 * a + ph[1] + k * 0.15) + 0.06 * Math.sin(5 * a + ph[2]);
          d += (j ? 'L' : 'M') + (cx + Math.cos(a) * R * m * 1.3).toFixed(1) + ' ' + (cy + Math.sin(a) * R * m).toFixed(1);
        }
        out += '<path d="' + d + 'Z"/>';
      }
    }
    svg.innerHTML = out;
    svg.dataset.drawn = '1';
  }

  /* ---------- būsena ---------- */
  function getMode() {
    try { return localStorage.getItem(KEY) || DEFAULT; } catch (e) { return DEFAULT; }
  }
  function setMode(mode) {
    try { localStorage.setItem(KEY, mode); } catch (e) {}
    apply(mode);
  }

  var money = (function () {
    var cur = 'EUR';
    var el = document.querySelector('[data-redy-checklist]');
    if (el && el.dataset.currency) cur = el.dataset.currency;
    var f = new Intl.NumberFormat('lt-LT', { style: 'currency', currency: cur });
    return function (cents) { return f.format(cents / 100); };
  })();

  function apply(mode) {
    document.querySelectorAll('[data-redy-mode]').forEach(function (b) {
      var on = b.dataset.redyMode === mode;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on);
    });
    document.querySelectorAll('[data-redy-show]').forEach(function (el) {
      el.hidden = el.dataset.redyShow !== mode;
    });
    document.querySelectorAll('[data-redy-draw]').forEach(function (p) {
      p.style.animation = 'none'; p.getBoundingClientRect(); p.style.animation = '';
    });
    document.querySelectorAll('[data-redy-products]').forEach(function (s) { sortProducts(s, mode); });
    document.querySelectorAll('[data-redy-checklist]').forEach(updateChecklist);
  }

  /* ---------- prekių žymos ---------- */
  function sortProducts(section, mode) {
    var grid = section.querySelector('.redy-tags');
    if (!grid) return;
    var limit = +section.dataset.limit || 4;
    var cards = Array.prototype.slice.call(grid.children);
    cards.forEach(function (c, i) { if (c.dataset.order === undefined) c.dataset.order = i; });
    cards.sort(function (a, b) {
      var am = (' ' + a.dataset.modes + ' ').indexOf(' ' + mode + ' ') > -1 ? 0 : 1;
      var bm = (' ' + b.dataset.modes + ' ').indexOf(' ' + mode + ' ') > -1 ? 0 : 1;
      return am - bm || a.dataset.order - b.dataset.order;
    });
    cards.forEach(function (c, i) { c.hidden = i >= limit; grid.appendChild(c); });
  }

  /* ---------- kelionės sąrašas ---------- */
  function updateChecklist(section) {
    var list = section.querySelector('[data-redy-list]:not([hidden])');
    if (!list) return;
    var boxes = list.querySelectorAll('input[type=checkbox]');
    var done = 0, miss = [], sum = 0;
    boxes.forEach(function (b) {
      if (b.checked) done++;
      else if (b.dataset.variant) { miss.push(+b.dataset.variant); sum += +b.dataset.price; }
    });
    var pct = boxes.length ? Math.round(done / boxes.length * 100) : 0;
    section.querySelector('[data-redy-fill]').style.width = pct + '%';
    section.querySelector('[data-redy-pct]').textContent = pct === 100 ? 'Tu REDY→' : pct + '% REDY';
    var missEl = list.querySelector('[data-redy-missing]');
    var btn = list.querySelector('[data-redy-add]');
    missEl.textContent = miss.length ? 'Trūksta ' + miss.length + ' · ' + money(sum) : 'Viskas supakuota!';
    btn.style.visibility = miss.length ? 'visible' : 'hidden';
    btn._redyMissing = miss;
  }

  function addMissing(section, btn) {
    var ids = btn._redyMissing || [];
    if (!ids.length) return;
    btn.disabled = true;
    fetch(section.dataset.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      window.location.href = section.dataset.cartUrl;
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = 'Nepavyko – bandyk dar kartą';
    });
  }

  /* ---------- paleidimas ---------- */
  function init() {
    document.querySelectorAll('[data-redy-topo]').forEach(drawTopo);
    document.querySelectorAll('[data-redy-checklist]').forEach(function (s) {
      if (s.dataset.bound) return;
      s.dataset.bound = '1';
      s.addEventListener('change', function () { updateChecklist(s); });
      s.addEventListener('click', function (e) {
        var b = e.target.closest('[data-redy-add]');
        if (b) addMissing(s, b);
      });
    });
    apply(getMode());
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-redy-mode]');
    if (b) setMode(b.dataset.redyMode);
  });
  document.addEventListener('DOMContentLoaded', init);
  /* temos redaktoriuje sekcijos perkraunamos */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target.closest && e.target.closest('[data-redy-show]');
    if (el) setMode(el.dataset.redyShow);
  });
})();
